/* eslint-disable max-lines */
import React from 'react'
import {
    AFTERSALES_60_DAYS_TIP_2,
    AFTERSALES_60_DAYS_TIP,
    WAIT_SUPPLIER_REISSUE_KEY
} from '@/modules/globals/constants/iknow'
import { daysBetweenDatesUnder30 } from '@/modules/distribute/components/ShortLinks/components/ChannelTopEnter/helper'
import FocusLabel from '@/modules/afterSale/components/FocusLabel'

export const allQuestionList = ['缺货', '线上已申请退款', '等待订单合并', '线上修改了地址', '预售']

/**
 *  取消订单原因
 */
export const cancelOrderResonList = ['商品缺货', '客户申请取消', '测试订单', '重复订单', '逾期未支付', '无效订单']

// 路由
export const CHANNEL_ORDER_ROUTE = '/channel/my/order/tower/distribute' // 渠道测代发订单路由
export const CHANNEL_GENERAL_ORDER_ROUTE = '/channel/my/order/tower/distribute' // 渠道测自发订单路由
export const CHANNEL_PROCE_QUANTITY = '/channel/my/supplierStockList' // 渠道测价格及库存
export const CHANNEL_AFTER_SALES_MANAGE = '/channel/my/sales/tower/afterSales' // 渠道侧售后管理
export const CHANNEL_AFTER_SALES_AUTOMATION = '/channel/my/sales/tower/afterSalesAutomation' // 渠道侧售后自动化
export const CHANNEL_AFTER_SALES_SETTINGS = '/channel/my/sales/tower/afterSalesSettings' // 渠道侧售后设置
export const CHANNEL_ORDER_SETTINGS = '/channel/my/pushBillDispose' // 渠道侧订单设置
export const CHANNEL_EXPRESS_INTERCEPTION = '/channel/my/sales/tower/expressInterception' // 渠道侧快递拦截
export const CHANNEL_EXPRESS_WARNING = '/channel/my/dataCenter/logisticsEarlyWarning' // 渠道侧物流预警
export const CHANNEL_HISTORY_ORDER = '/channel/my/archiveOrderList' // 渠道侧历史订单

export const SUPPLIER_ORDER_ROUTE = '/suppliersManage/tower/distribute' // 供应测分销订单路由
export const SUPPLIER_GENERAL_ORDER_ROUTE = '/suppliersManage/tower/distribute' // 供应测普通订单路由
export const SUPPLIER_PROCE_QUANTITY = '/suppliersManage/supplierStockList' // 供应测价格及库存
export const SUPPLIER_AFTER_SALES_MANAGE = '/afterSaleManage/afterSales' // 供应侧售后管理
export const SUPPLIER_DISTRIBUTOR_AFTER_SALES = '/afterSaleManage/distributorAfterSales' // 供应侧分销商的售后管理
export const SUPPLIER_AFTER_SALES_AUTOMATION = '/afterSaleManage/afterSalesAutomation' // 供应侧售后自动化
export const SUPPLIER_AFTER_SALES_SETTINGS = '/afterSaleManage/afterSalesSettings' // 供应侧售后设置
export const SUPPLIER_ORDER_SETTINGS = '/tradeManage/suppliersManage/pushBillDispose' // 供应侧订单设置
export const SUPPLIER_EXPRESS_INTERCEPTION = '/afterSaleManage/expressInterception' // 供应侧快递拦截
export const SUPPLIER_EXPRESS_WARNING = '/dataCenter/logisticsEarlyWarning' // 供应侧物流预警
export const SUPPLIER_MYPARTNER = '/partnerManage/myPartner' // 供应侧我的分销商
export const SUPPLIER_DELIVERY = '/printManage/supplierTrade/tradePrint/delivery' // 供应侧我的分销商
export const SUPPLIER_AUDIT = '/printManage/supplierTrade/tradePrint/audit' // 供应侧订单-待审核
export const SUPPLIER_SENT = '/printManage/supplierTrade/tradePrint/send' // 供应侧订单-已发货
export const SUPPLIER_BRANCH_SENT = '/printManage/supplierTrade/tradePrint/branchSent' // 供应侧订单-已发货-分仓角色
export const SUPPLIER_ORDER_MANAGE = '/tradeManage/tower/distribute' // 供应侧 订单管理
export const SUPPLIER_HISTORY_ORDER = '/tradeManage/archiveOrderList' // 供应侧 历史订单

export const SUPPLIER_PRINT_ALL_ORDER = '/printManage/supplierTrade/tradePrint/allOrders' // 供应侧-打单全部订单
export const CHANNEL_PRINT_ALL_ORDER = '/channel/my/printManage/channelTrade/tradePrint/allOrders' // 分销侧-打单全部订单
export const CHANNEL_PRINT_DELIVERY = '/channel/my/printManage/channelTrade/tradePrint/delivery' // 分销侧-打单代发货订单
export const CHANNEL_AUDIT = '/channel/my/printManage/channelTrade/tradePrint/audit' // 分销侧订单-待审核

export const SUPPLIER_ONLINE_SUPPLIERS = '/suppliersManage/suppliersList/onlineSuppliers' // 点击“我是分销商”跳转到供应商端-“我的供应商”页面
export const CHANNEL_HOME_PAGE = '/channel/my/businessDynamics' // 点击“我是分销商”跳转到分销商端-首页

export const SUPPLIER_SHOP_LIST = '/storeManage/list'
export const CHANNEL_SHOP_LIST = '/channel/my/storeManage'
/**
 * 合伙人供应侧
 */
export const SUPPLY_PRATER_SHIP = '/partnership'
/**
 * 合伙人渠道侧
 */
export const CHANNEL_PRATER_SHIP = '/channel/my/partnership'

export const PAGE_TAB_ERP_KEY = 'PAGE_TAB_ERP_KEY' // 顶部tab跳转到erp
export const ERP_ORDER_PAGE_URL = 'erpOrderPage' // 顶部tab跳转到erp

// 售后管理 售后单（筛选条件）状态类型
export const AFTERSALES_MUST_SEE = 1003 // 售后必看
export const REFUND_OVERDUE = 1001 // 退款快逾期
export const RETURN_REFUND_OVERDUE = 1002 // 退货退款快逾期
export const RETURN_HOUSE_ABNORMAL = 1004 // 退货入库异常
export const RETURN_HOUSE_NOSTOCK = 1005 // 已退款未入库
export const PLATFORM_FAST_REFUND = 1006 // 平台极速退款
export const LOGISTICS_INTERCEPTION = 6032 // 中通物流待拦截
export const LOGISTICS_INTERCEPTION_BLOCKED = 1007 // 中通物流已拦截
export const WAIT_REFUN = 3 // 退款待处理
export const SEND_BEFORE_WAIT_REFUN = 2001 // 未发货仅退款
export const SEND_AFTER_WAIT_REFUN = 2002 // 已发货仅退款
export const WAIT_RETURN_GOODS = 2003 // 退货待处理
export const WAIT_RECEIPT_REFUND = 2004 // 买家已退货
export const WAIT_SUBMIT_TO_SUPPLIER = 2005 // 待提交给供应商
export const WAIT_SUPPLIER_REFUND = 2006 // 待供应商退款

export const WAIT_BUYER_RETURN = 2007 // 待买家退货
export const WAIT_RECEIPT_REFUND_1 = 2009 // 待确认收货退款
export const WAIT_RECEIPT_REFUND_2 = 2010 // 已收货可退款

/** 退货地址异常的售后单（分销+） */
export const RETURN_ADDRESS_ABNORMAL = 2011

/** 退货地址异常的售后单（分销+供销+） */
export const RETURN_ADDRESS_ABNORMAL_DIS = 2012

export const WAIT_SUPPLIER_REFUND_1 = 2016 // 待供应商确认
export const WAIT_SUPPLIER_REFUND_2 = 2026 // 供应商已确认待退款
export const OTHER = 3002 // 其他
export const WAIT_WARE_HOUSING = 3001 // 待入库
export const SUPPLIER_REJECTION = 2039 // 供应商驳回待处理

// 分销商的售后单
export const SMALL_PAID_DIS = 2051 // 小额赔付
export const WAIT_SUBMIT_SUPPLIER_DIS = 6001 // 待提交给供应商
export const WAIT_SUPPLIER_REFUND_DIS = 6002 // 待供应商退款
export const WAIT_SUPPLIER_REFUND_DIS_1 = 6012 // 待供应商确认
export const WAIT_SUPPLIER_REFUND_DIS_2 = 6022 // 供应商已确认待退款
export const WAIT_REFUND_TO_DISTRIBUTOR_DIS = 4003 // 待退款给分销商(前端用于匹配子集如4003-4001,4003-4001)
export const WAIT_REFUND_TO_DISTRIBUTOR_DIS_1 = 4001 // 自发已确认，可退
export const WAIT_REFUND_TO_DISTRIBUTOR_DIS_2 = 4002 // 供应商已退款，可退
export const RETURN_HOUSE_ABNORMAL_DIS = 1014 // 退货入库异常
export const LOGISTICS_INTERCEPTION_DIS = 6042 // 中通物流待拦截
export const SUPPLIER_REJECTION_DIS = 2040 // 供应商驳回待处理

// 售后、分销商售后 公用
export const WAIT_SUPPLIER_REISSUE = 2036 // 待供应商补发
export const WAIT_SUPPLIER_REISSUE_1 = 2037 // 供应商未确认补发
export const WAIT_SUPPLIER_REISSUE_2 = 2038 // 供应商已确认补发
export const AUTO_SUBMIT_FAIL = 5001 // 自动提交供应商失败
/** 已发货待拦截 */
export enum ShippedInterception {
    all = 6036,
    onLineIntercept = 6037,
    offlineIntercept = 6038
}

// 快捷拦截登记
export const TOBE_INTERCEPTED = '待拦截'
export const APPLIED_INTERCEPTED = '已发起拦截'
export const INTERCEPTED_SUCCESS = '拦截成功'
export const MAP_INTERCEPTED_CODE = {
    [TOBE_INTERCEPTED]: 6033,
    [APPLIED_INTERCEPTED]: 6034,
    [INTERCEPTED_SUCCESS]: 6035
}
export const MAP_INTERCEPTED_VALUE = {
    [APPLIED_INTERCEPTED]: '标记申请拦截,标记拦截成功',
    [INTERCEPTED_SUCCESS]: '标记拦截成功'
}

export const SFTER_SALES_STATUS_MAP = {
    [WAIT_REFUN]: '退款待处理',
    [SEND_BEFORE_WAIT_REFUN]: '未发货仅退款',
    [SEND_AFTER_WAIT_REFUN]: '已发货仅退款',
    [WAIT_RETURN_GOODS]: '退货待处理',
    [WAIT_BUYER_RETURN]: '待买家退货',
    [WAIT_RECEIPT_REFUND]: '买家已退货',
    [WAIT_RECEIPT_REFUND_1]: '待确认收货退款',
    [WAIT_RECEIPT_REFUND_2]: '已收货可退款',
    [WAIT_WARE_HOUSING]: '待入库',
    [WAIT_SUBMIT_TO_SUPPLIER]: <FocusLabel text1="待提交" focusText="给供应商" />,
    [AUTO_SUBMIT_FAIL]: <FocusLabel text1="自动提交供应商" focusText="失败" />,
    [WAIT_SUPPLIER_REFUND]: '待供应商退款',
    [WAIT_SUPPLIER_REFUND_1]: '待供应商确认',
    [WAIT_SUPPLIER_REFUND_2]: '供应商已确认待退款',
    [WAIT_SUPPLIER_REISSUE]: '待供应商补发',
    [WAIT_SUPPLIER_REISSUE_1]: '供应商未确认补发',
    [WAIT_SUPPLIER_REISSUE_2]: '供应商已确认补发',
    [SUPPLIER_REJECTION]: <FocusLabel text1="供应商" text2="待处理" focusText="驳回" />,
    [OTHER]: '其他',
    [SUPPLIER_REJECTION_DIS]: <FocusLabel text1="供应商" text2="待处理" focusText="驳回" />,
    [WAIT_SUBMIT_SUPPLIER_DIS]: <FocusLabel text1="待提交" focusText="给供应商" />,
    [WAIT_SUPPLIER_REFUND_DIS]: '待供应商退款',
    [WAIT_SUPPLIER_REFUND_DIS_1]: '待供应商确认',
    [WAIT_SUPPLIER_REFUND_DIS_2]: '供应商已确认待退款',
    [WAIT_REFUND_TO_DISTRIBUTOR_DIS]: '待退款给分销商',
    [WAIT_REFUND_TO_DISTRIBUTOR_DIS_1]: '自发已确认，可退',
    [WAIT_REFUND_TO_DISTRIBUTOR_DIS_2]: '供应商已退款，可退'
}
// 未发货仅退款, 已发货仅退款, 退货待处理,待买家退货, 买家已退货选中隐藏【手工创建售后单】、【无信息件绑定订单】
export const HIDDEN_MENUAL_CREATE_AND_NO_INFO_BTN_ORDER_STATUS = [
    WAIT_RECEIPT_REFUND,
    WAIT_RETURN_GOODS,
    SEND_AFTER_WAIT_REFUN,
    SEND_BEFORE_WAIT_REFUN,
    WAIT_BUYER_RETURN
]
// 我知道了，匹配对应的文案
const MAP_IKNOW_TEXT = {
    [WAIT_SUPPLIER_REISSUE]: '及时查看和跟进供应商补发进度～'
}
// 我知道了，匹配对应的name
const MAP_IKNOW_KEY = {
    [WAIT_SUPPLIER_REISSUE]: WAIT_SUPPLIER_REISSUE_KEY
}
const SUPPLIER_REJECTION_TEXT =
    '您的售后单被供应商驳回，通过供分销备注可查看被驳回的原因，按要求调整后先取消异常，再重新提交'
const WAIT_SUBMIT_SUPPLIER_TEXT = '当前系统中需要您手动操作提交供应商'
// 匹配对应的问号提示文案
const MAP_QUESTION_TEXT = {
    [SUPPLIER_REJECTION]: SUPPLIER_REJECTION_TEXT,
    [SUPPLIER_REJECTION_DIS]: SUPPLIER_REJECTION_TEXT,
    [AUTO_SUBMIT_FAIL]: '系统自动提交供应商失败的单据，可在日志中查看失败原因，按要求调整后再重新手动提交',
    [WAIT_SUBMIT_TO_SUPPLIER]: WAIT_SUBMIT_SUPPLIER_TEXT,
    [WAIT_SUBMIT_SUPPLIER_DIS]: WAIT_SUBMIT_SUPPLIER_TEXT
}
// 展示new 标记
const SHOW_NEW_KEY = [
    { key: AUTO_SUBMIT_FAIL, createTime: '2025-02-20' },
    { key: SUPPLIER_REJECTION, createTime: '2025-02-20' },
    { key: SUPPLIER_REJECTION_DIS, createTime: '2025-02-20' },
    { key: WAIT_REFUND_TO_DISTRIBUTOR_DIS, createTime: '2024-09-05' },
    {
        key: WAIT_RETURN_GOODS,
        createTime: '2024-12-12',
        icon: 'https://assets.sursung.com/activity/20241209/FCD3514C2ABB424EA190F15FA7D396701733709382278.png',
        iconTipMsg: '分销+售后单，可根据不同供应商退货地址进行退货'
    }
]
const getIshowNew = key => {
    const item = SHOW_NEW_KEY.find(item => item.key === key)
    if (item?.createTime) {
        return daysBetweenDatesUnder30(item.createTime)
    }
    return !!item
}
const getCornerMarkIconUrl = key => {
    const item = SHOW_NEW_KEY.find(item => item.key === key)
    return item?.icon
}
const getCornerMarkIconTipMsg = key => {
    const item = SHOW_NEW_KEY.find(item => item.key === key)
    return item?.iconTipMsg
}
// 侧边栏  需要新起一行
const NEED_BLOCK_LINE = [
    WAIT_SUBMIT_TO_SUPPLIER,
    SUPPLIER_REJECTION,
    SUPPLIER_REJECTION_DIS,
    WAIT_REFUND_TO_DISTRIBUTOR_DIS,
    AUTO_SUBMIT_FAIL
]

// 售后管理状态筛选列表
export const SFTER_SALES_STATUS_LIST = [
    SEND_BEFORE_WAIT_REFUN,
    SEND_AFTER_WAIT_REFUN,
    WAIT_RETURN_GOODS,
    WAIT_BUYER_RETURN,
    WAIT_RECEIPT_REFUND,
    WAIT_SUBMIT_TO_SUPPLIER,
    SUPPLIER_REJECTION,
    AUTO_SUBMIT_FAIL,
    WAIT_SUPPLIER_REFUND,
    WAIT_SUPPLIER_REISSUE,
    WAIT_WARE_HOUSING,
    OTHER
].map(v => {
    return {
        label: SFTER_SALES_STATUS_MAP[v],
        value: v,
        tipText: MAP_IKNOW_TEXT[v],
        storageKey: MAP_IKNOW_KEY[v],
        isNew: getIshowNew(v),
        cornerMarkIconUrl: getCornerMarkIconUrl(v),
        cornerMarkIconTipMsg: getCornerMarkIconTipMsg(v),
        questionTip: MAP_QUESTION_TEXT[v],
        tips: null,
        name: [
            SEND_BEFORE_WAIT_REFUN,
            SEND_AFTER_WAIT_REFUN,
            WAIT_RETURN_GOODS,
            WAIT_RECEIPT_REFUND,
            WAIT_BUYER_RETURN
        ].includes(v)
            ? AFTERSALES_60_DAYS_TIP_2
            : AFTERSALES_60_DAYS_TIP,
        dataLogText: SFTER_SALES_STATUS_MAP[v]
    }
})

const STATUS_WIDTH_MAP = {
    [SEND_BEFORE_WAIT_REFUN]: 112,
    [SEND_AFTER_WAIT_REFUN]: 112,
    [WAIT_RETURN_GOODS]: 112,
    [WAIT_BUYER_RETURN]: 112,
    [WAIT_RECEIPT_REFUND]: 112,
    [WAIT_SUBMIT_TO_SUPPLIER]: 228,
    [WAIT_WARE_HOUSING]: 92,
    [WAIT_SUPPLIER_REFUND]: 132,
    [WAIT_SUPPLIER_REISSUE]: 228,
    [AUTO_SUBMIT_FAIL]: 228,
    [SUPPLIER_REJECTION]: 228,
    [OTHER]: 92
}

// 售后管理状态筛选列表，侧边栏筛选使用，顺序、宽度有要求
export const SIDE_SFTER_SALES_STATUS_LIST = [
    SEND_BEFORE_WAIT_REFUN,
    SEND_AFTER_WAIT_REFUN,
    WAIT_RETURN_GOODS,
    WAIT_BUYER_RETURN,
    WAIT_RECEIPT_REFUND,
    WAIT_SUBMIT_TO_SUPPLIER,
    SUPPLIER_REJECTION,
    AUTO_SUBMIT_FAIL,
    WAIT_WARE_HOUSING,
    WAIT_SUPPLIER_REFUND,
    WAIT_SUPPLIER_REISSUE,
    OTHER
].map(v => {
    return {
        label: SFTER_SALES_STATUS_MAP[v],
        value: v,
        tipText: MAP_IKNOW_TEXT[v],
        storageKey: MAP_IKNOW_KEY[v],
        isNew: getIshowNew(v),
        cornerMarkIconUrl: getCornerMarkIconUrl(v),
        cornerMarkIconTipMsg: getCornerMarkIconTipMsg(v),
        blockLine: NEED_BLOCK_LINE?.includes(v),
        questionTip: MAP_QUESTION_TEXT[v],
        tips: null,
        name: [
            SEND_BEFORE_WAIT_REFUN,
            SEND_AFTER_WAIT_REFUN,
            WAIT_RETURN_GOODS,
            WAIT_RECEIPT_REFUND,
            WAIT_BUYER_RETURN
        ].includes(v)
            ? AFTERSALES_60_DAYS_TIP_2
            : AFTERSALES_60_DAYS_TIP,
        dataLogText: SFTER_SALES_STATUS_MAP[v],
        style: {
            width: `${STATUS_WIDTH_MAP[v]}px`
        }
    }
})

// 分销商的售后单状态筛选列表
export const DISTRIBUTOR_AFTERSALES_STATUS_LIST = [
    WAIT_WARE_HOUSING,
    WAIT_SUPPLIER_REFUND_DIS,
    WAIT_REFUND_TO_DISTRIBUTOR_DIS,
    WAIT_SUPPLIER_REISSUE,
    WAIT_SUBMIT_SUPPLIER_DIS,
    SUPPLIER_REJECTION_DIS,
    AUTO_SUBMIT_FAIL
].map(v => {
    return {
        label: SFTER_SALES_STATUS_MAP[v],
        value: v,
        tipText: MAP_IKNOW_TEXT[v],
        storageKey: MAP_IKNOW_KEY[v],
        isNew: getIshowNew(v),
        blockLine: NEED_BLOCK_LINE?.includes(v),
        questionTip: MAP_QUESTION_TEXT[v],
        style: {
            width: `100%`
        }
    }
})

// 售后管理-平台
export const AFTERSALES_PLATFORM_TAOBAO = '淘宝天猫'
export const AFTERSALES_PLATFORM_BILIBILI = 'B站会员购'
export const AFTERSALES_PLATFORM_DOUYIN = '头条放心购'
export const AFTERSALES_PLATFORM_PINDUODUO = '拼多多'
export const AFTERSALES_PLATFORM_KUAISHOU = '快手电商'
export const AFTERSALES_PLATFORM_WXCHANNEL = '微信视频号'
export const AFTERSALES_PLATFORM_JD = '京东商城'
export const AFTERSALES_PLATFORM_YOUZAN = '有赞微商城'
export const AFTERSALES_PLATFORM_ALIBABA = '阿里巴巴'
export const AFTERSALES_PLATFORM_RED_BOOK = '小红书'

export const AFTERSALES_PLATFORM_NAME_MAP = {
    [AFTERSALES_PLATFORM_TAOBAO]: '淘宝天猫',
    [AFTERSALES_PLATFORM_DOUYIN]: '头条放心购',
    [AFTERSALES_PLATFORM_PINDUODUO]: '拼多多',
    [AFTERSALES_PLATFORM_KUAISHOU]: '快手电商',
    [AFTERSALES_PLATFORM_WXCHANNEL]: '微信小店',
    [AFTERSALES_PLATFORM_JD]: '京东商城',
    [AFTERSALES_PLATFORM_BILIBILI]: 'B站会员购',
    [AFTERSALES_PLATFORM_YOUZAN]: '有赞微商城',
    [AFTERSALES_PLATFORM_RED_BOOK]: '小红书'
}

// 售后管理-淘系平台店铺类型
export const AFTERSALES_SHOPTYPE_TAOTE = '淘宝特价版'
export const AFTERSALES_SHOPTYPE_TAOBAO = '淘宝'
export const AFTERSALES_SHOPTYPE_TIANMAO = '天猫'

export const AFTERSALES_PLATFORM_LIST = [
    {
        shopSite: AFTERSALES_PLATFORM_TAOBAO,
        shopType: AFTERSALES_SHOPTYPE_TAOBAO
    },
    {
        shopSite: AFTERSALES_PLATFORM_TAOBAO,
        shopType: AFTERSALES_SHOPTYPE_TIANMAO
    },
    {
        shopSite: AFTERSALES_PLATFORM_BILIBILI,
        shopType: AFTERSALES_PLATFORM_BILIBILI
    },
    {
        shopSite: AFTERSALES_PLATFORM_PINDUODUO,
        shopType: AFTERSALES_PLATFORM_PINDUODUO
    },
    {
        shopSite: AFTERSALES_PLATFORM_DOUYIN,
        shopType: AFTERSALES_PLATFORM_DOUYIN
    },
    {
        shopSite: AFTERSALES_PLATFORM_KUAISHOU,
        shopType: AFTERSALES_PLATFORM_KUAISHOU
    },
    {
        shopSite: AFTERSALES_PLATFORM_WXCHANNEL,
        shopType: AFTERSALES_PLATFORM_WXCHANNEL
    },
    {
        shopSite: AFTERSALES_PLATFORM_RED_BOOK,
        shopType: AFTERSALES_PLATFORM_RED_BOOK
    },
    {
        shopSite: AFTERSALES_PLATFORM_JD,
        shopType: AFTERSALES_PLATFORM_JD
    },
    {
        shopSite: AFTERSALES_PLATFORM_YOUZAN,
        shopType: AFTERSALES_PLATFORM_YOUZAN
    }
]

// 售后管理 同意退货 不同平台对应不同维护退货地址链接
export const AFTERSALES_PLATFORM_ADDRESS_MAP = {
    [AFTERSALES_PLATFORM_TAOBAO]:
        'https://wuliu.taobao.com/user/consign_setting.htm?spm=a21we.8289863.0.0.28a82d9cudyZNZ&tab_source=contactSetting',
    [AFTERSALES_PLATFORM_DOUYIN]: 'https://fxg.jinritemai.com/ffa/morder/logistics/address-list',
    [AFTERSALES_PLATFORM_PINDUODUO]: 'https://mms.pinduoduo.com/orders/order/carriage/addressManagement',
    [AFTERSALES_PLATFORM_KUAISHOU]: 'https://s.kwaixiaodian.com/zone-origin/express/address',
    [AFTERSALES_PLATFORM_WXCHANNEL]: 'https://channels.weixin.qq.com/shop/address/expressAddressMgmt',
    [AFTERSALES_PLATFORM_BILIBILI]: 'https://shop.bilibili.com/#/db/home',
    [AFTERSALES_PLATFORM_RED_BOOK]: 'https://ark.xiaohongshu.com/app-order/logistics/tools?tabIndex=0'
}

// 售后管理 拒绝操作类型key
export const REFUND_ONLY_KEY = 'RefundOnly' // 仅退款
export const GENERAL_RETURN_KEY = 'GeneralReturn' // 普通退货-一审
export const REJECT_RETURN_KEY = 'RejectReturn' // 拒收退货-二审

// 售后管理 检查子账号类型枚举
export const SUBACCOUNT_NORMAL = '0' // 正常
export const SUBACCOUNT_NOT_OPEND = '1' // 未设置子账号
export const SUBACCOUNT_DISABLED = '2' // 默认子账号被停用
export const SUBACCOUNT_NOT_DEFAULT = '3' // 未设置默认子账号
export const SUBACCOUNT_NOT_AUTH = '4' // 未授权子账号
export const SUBACCOUNT_FROZEN = '5' // 冻结子账号
export const SUBACCOUNT_NO_PERMISSION = '6' // 子账号在平台没有售后权限
export const SUBACCOUNT_OVERDUE = 'overdue' // 子账号已过期（这是前台自定义的一个枚举）

// 售后页面按钮权限key开始========
export const AGREE_TO_AREFUND = 'afterSale.AGREE_TO_AREFUND' // 同意退款
export const AGREE_RETURN_REFUND = 'afterSale.AGREE_RETURN_REFUND' // 同意退货退款
export const REFUSED_TO_AREFUND = 'afterSale.REFUSED_TO_AREFUND' // 拒绝退款
export const CONFIRM_THE_GOODS = 'afterSale.CONFIRM_THE_GOODS' // 确认收货
export const AGREE_TO_RETURN = 'afterSale.AGREE_TO_RETURN' // 同意退货
export const REFUSED_TO_RETURN = 'afterSale.REFUSED_TO_RETURN' // 拒绝退货
export const BUYER_RETURN_ANOMALIES_AND_DISMISS_REFUND = 'afterSale.BUYER_RETURN_ANOMALIES_AND_DISMISS_REFUND' // 买家退货异常，驳回退款
export const SELF_CREATE = 'afterSale.SELF_CREATE' // 手工创建售后单
export const SELF_CREATE_NO_INFO = 'afterSale.SELF_CREATE_NO_INFO' // 登记无信息件
export const NO_INFO_BIND_ORDER = 'afterSale.NO_INFO_BIND_ORDER' // 认领无信息件
export const CONFIRM = 'afterSale.CONFIRM' // 确认
export const RECONFIRM = 'afterSale.RECONFIRM' // 反确认
export const BATCH_UPDATE_AMOUNT = 'afterSale.BATCH_UPDATE_AMOUNT' // 批量修改金额
export const CANCEL_RECEIPT = 'afterSale.CANCEL_RECEIPT' // 取消收货
export const INVALID = 'afterSale.INVALID' // 作废
export const EXPORT = 'afterSale.EXPORT' // 导出
export const SUBMIT_SUPPLIER = 'afterSale.SUBMIT_SUPPLIER' // 提交给供应商
export const AFTERSALE_SET_ORDER_REMARK = 'afterSale.SET_ORDER_REMARK' // 售后设置备注， 旗帜
export const SUBMIT_DIS = 'afterSale.SUBMIT_DIS' // 提交给分销商
export const MODIFY_PROCESS_RESULT = 'afterSale.MODIFY_PROCESS_RESULT' // 修改处理结果
export const PROCESS_RESULT = 'afterSale.PROCESS_RESULT' // 处理结果
// 售后页面按钮权限key结束========

/** 订单退款状态 */
export enum OrderRefundStatus {
    /** 待审核 */
    WAIT_CONFIRM = 'WaitConfirm',

    /** 已确认 */
    CONFIRMED = 'Confirmed',

    /** 完成 */
    FINISHED = 'Finished',

    /** 作废 */
    CANCELLED = 'Cancelled'
}

// 售后管理-供应商退款状态枚举-
// 同分销商退款状态枚举
export const AFTERSALES_WAITCONFIRM = OrderRefundStatus.WAIT_CONFIRM
export const AFTERSALES_CONFIRMED = OrderRefundStatus.CONFIRMED
export const AFTERSALES_FINISHED = OrderRefundStatus.FINISHED
export const AFTERSALES_CANCELLED = OrderRefundStatus.CANCELLED

export const AFTERSALES_SUPPLIER_REFUND_STATUS_MAP = {
    [AFTERSALES_WAITCONFIRM]: '待审核',
    [AFTERSALES_CONFIRMED]: '已确认',
    [AFTERSALES_FINISHED]: '完成',
    [AFTERSALES_CANCELLED]: '作废'
}

export const AFTERSALES_CHANNEL_REFUND_STATUS_MAP = {
    [AFTERSALES_WAITCONFIRM]: '待审核',
    [AFTERSALES_CONFIRMED]: '已退款',
    [AFTERSALES_FINISHED]: '已退款',
    [AFTERSALES_CANCELLED]: '作废'
}

// ===创建售后单开始===
// 售后分类 对用的退货类型
export const GENERAL_RETURN = '普通退货'
export const REFUND_ONLY = '仅退款'
export const EXCHANGE_GOODS = '换货'
export const REISSUE = '补发'
export const REPAIR = '维修'
export const REFUSE_RETURN = '拒收退货'
// 商品列表 对用的退货类型
export const RETURN_GOODS = '退货'
export const OTHER_TYPE = '其它'
export const EXCHANGE_GOODS_2 = '换货'
export const REISSUE_2 = '补发'
export const REPAIR_2 = '维修'

export const QUESTION_TYPE_NULL = '无'
export const QUESTION_TYPE_NOSENT = '应发未发'
export const QUESTION_TYPE_SENT = '错发已发'

// ===创建售后单结束===

// 售后快递拦截 超过拦截申请时间 ====开始=====
export const TIME_OUT_INTERCEPT_DAY_24_HOUR = 1
export const TIME_OUT_INTERCEPT_DAY_48_HOUR = 2
export const TIME_OUT_INTERCEPT_DAY_72_HOUR = 3
export const TIME_OUT_INTERCEPT_DAY_7_DAY = 7

export const TIME_OUT_INTERCEPT_DAY_MAP = {
    [TIME_OUT_INTERCEPT_DAY_24_HOUR]: '24小时',
    [TIME_OUT_INTERCEPT_DAY_48_HOUR]: '48小时',
    [TIME_OUT_INTERCEPT_DAY_72_HOUR]: '72小时',
    [TIME_OUT_INTERCEPT_DAY_7_DAY]: '7天'
}

export const TIME_OUT_INTERCEPT_DAY_LIST = [
    TIME_OUT_INTERCEPT_DAY_24_HOUR,
    TIME_OUT_INTERCEPT_DAY_48_HOUR,
    TIME_OUT_INTERCEPT_DAY_72_HOUR,
    TIME_OUT_INTERCEPT_DAY_7_DAY
].map(v => ({
    label: TIME_OUT_INTERCEPT_DAY_MAP[v],
    value: v
}))

// 售后快递拦截 超过拦截申请时间 ====结束=====
